var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResources(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 27,
    viewBox: "0 0 30 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5001 5.69565C28.5001 6.34399 27.9745 6.86956 27.3261 6.86956H12.0653C11.4169 6.86956 10.8914 6.34399 10.8914 5.69565V2.17391C10.8914 1.52558 11.4169 1 12.0653 1H27.3261C27.9745 1 28.5001 1.52558 28.5001 2.17391V5.69565Z",
    stroke: "#373737",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5001 15.0869C28.5001 15.7353 27.9745 16.2609 27.3261 16.2609H12.0653C11.4169 16.2609 10.8914 15.7353 10.8914 15.0869V11.5652C10.8914 10.9169 11.4169 10.3913 12.0653 10.3913H27.3261C27.9745 10.3913 28.5001 10.9169 28.5001 11.5652V15.0869Z",
    stroke: "#373737",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5001 24.4783C28.5001 25.1266 27.9745 25.6522 27.3261 25.6522H12.0653C11.4169 25.6522 10.8914 25.1266 10.8914 24.4783V20.9566C10.8914 20.3082 11.4169 19.7827 12.0653 19.7827H27.3261C27.9745 19.7827 28.5001 20.3082 28.5001 20.9566V24.4783Z",
    stroke: "#373737",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.36956 5.69565C7.36956 6.34399 6.84399 6.86956 6.19565 6.86956H2.67391C2.02558 6.86956 1.5 6.34399 1.5 5.69565V2.17391C1.5 1.52558 2.02558 1 2.67391 1H6.19565C6.84399 1 7.36956 1.52558 7.36956 2.17391V5.69565Z",
    stroke: "#373737",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.36956 15.0869C7.36956 15.7353 6.84399 16.2609 6.19565 16.2609H2.67391C2.02558 16.2609 1.5 15.7353 1.5 15.0869V11.5652C1.5 10.9169 2.02558 10.3913 2.67391 10.3913H6.19565C6.84399 10.3913 7.36956 10.9169 7.36956 11.5652V15.0869Z",
    stroke: "#373737",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.36956 24.4783C7.36956 25.1266 6.84399 25.6522 6.19565 25.6522H2.67391C2.02558 25.6522 1.5 25.1266 1.5 24.4783V20.9566C1.5 20.3082 2.02558 19.7827 2.67391 19.7827H6.19565C6.84399 19.7827 7.36956 20.3082 7.36956 20.9566V24.4783Z",
    stroke: "#373737",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResources);
export default __webpack_public_path__ + "static/media/resources.4b89470566fad75fa77d180be8e68fd5.svg";
export { ForwardRef as ReactComponent };